import gql from 'graphql-tag';

export const DeleteParticipantTask = gql`
  mutation DeleteParticipantTask(
    $organizationId: ID!
    $participantId: ID!
    $participantTaskId: ID!
  ) {
    deleteParticipantTask(
      organizationId: $organizationId
      participantId: $participantId
      participantTaskId: $participantTaskId
    ) {
      id
    }
  }
`;
